import React from "react";
import { countWords } from "../../../Utils";

export const WordCountHint = ({ text, limits }) => {
  if (!text) return null;

  return (
    <div className="testerWordCountHint">
      Word count: {countWords(text)}
      {limits?.minWords > 0 && ` (min: ${limits.minWords})`}
      {limits?.maxWords > 0 && ` (max: ${limits.maxWords})`}
    </div>
  );
};
